import { render, staticRenderFns } from "./newAndOld_analysis.vue?vue&type=template&id=4096afc4&scoped=true"
import script from "./newAndOld_analysis.vue?vue&type=script&lang=js"
export * from "./newAndOld_analysis.vue?vue&type=script&lang=js"
import style0 from "./newAndOld_analysis.vue?vue&type=style&index=0&id=4096afc4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4096afc4",
  null
  
)

export default component.exports